import { render } from "./waitBackground.vue?vue&type=template&id=30938eec&scoped=true"
import script from "./waitBackground.vue?vue&type=script&lang=js"
export * from "./waitBackground.vue?vue&type=script&lang=js"

import "./waitBackground.vue?vue&type=style&index=0&id=30938eec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30938eec"]])

export default __exports__